'use strict';

bbw.directive.bbwTouchClickTitle = ['$rootScope', 'bbw.LayoutTypeSvc', 'growl', function($rootScope, layoutType, growl) {
    return {
        link: function(scope, element, attrs) {
            if (layoutType.hasTouch()) {
                element.bind('click', function($event) {
                    $event.stopPropagation();
                    $event.preventDefault();
                    var title = '' + attrs.title;
                    if (title.length) {
                        $rootScope.$safeApply(function() {
                            growl.info(title);
                        });
                    }
                });
            }
        }
    };
}];
